import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Defaults mirror backend DEFAULT_SETTINGS so the site renders nicely
// even if the API is slow or briefly unavailable on first paint.
export const DEFAULT_SITE = {
  hero: {
    location_label: "Portland, Oregon",
    headline_line1: "Detail beyond",
    headline_line2: "expectation.",
    subtitle:
      "Hand-finished interior, exterior, and full premium detailing for drivers who refuse the ordinary. Booked by appointment in the heart of Portland.",
    tagline_footer: "Est. 2024 · By appointment only",
  },
  packages: [
    {
      id: "interior",
      name: "Interior",
      price: 75,
      tagline: "Cabin-grade detail",
      features: [
        "Full vacuum & blow-out",
        "Carpet & upholstery shampoo",
        "Leather / vinyl conditioning",
        "Dashboard & console polish",
        "Glass cleaned inside",
      ],
    },
    {
      id: "exterior",
      name: "Exterior",
      price: 75,
      tagline: "Showroom shine",
      features: [
        "Two-bucket hand wash",
        "Premium carnauba wax",
        "Tire dressing & shine",
        "Wheel & wheel-well clean",
        "Streak-free exterior glass",
      ],
    },
    {
      id: "premium",
      name: "Premium",
      price: 125,
      tagline: "The full Overdrive",
      features: [
        "Everything in Interior",
        "Everything in Exterior",
        "Clay-bar decontamination",
        "Paint sealant for lasting gloss",
        "Engine bay wipe-down",
      ],
    },
  ],
  about: {
    title_line1: "Built in Portland.",
    title_line2: "Obsessed with finish.",
    paragraph1:
      "Replace this with your story — how Overdrive Auto Spa started, what drives you, and why Portland drivers trust you with their vehicles.",
    paragraph2:
      "Tell readers about your hands-on process, the products you use, and your commitment to a finish that turns heads on the I-5.",
    stats: [
      { number: "500+", label: "Vehicles detailed" },
      { number: "4.9", label: "Avg. review" },
      { number: "3", label: "Signature packages" },
      { number: "100%", label: "Hand-finished" },
    ],
  },
  contact: {
    phone: "(503) 555-0123",
    phone_note: "Placeholder — replace",
    email: "hello@overdriveautospa.com",
    email_note: "Placeholder — replace",
    address: "Portland, Oregon area",
    address_note: "Address coming soon",
    hours: "Mon–Sat · 8AM–6PM",
    hours_note: "By appointment only",
  },
  footer: {
    description: "Portland, Oregon · Hand-finished detailing by appointment.",
    copyright_name: "Overdrive Auto Spa",
  },
};

export default function useSiteSettings() {
  const [settings, setSettings] = useState(DEFAULT_SITE);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await axios.get(`${API}/site`);
        if (!cancelled && data && typeof data === "object") {
          setSettings({ ...DEFAULT_SITE, ...data });
        }
      } catch {
        // keep defaults
      } finally {
        if (!cancelled) setLoaded(true);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return { settings, loaded };
}
